import { Service } from '@tino-frontend/adapters'

import type { GetPostalCodeInfoResponse } from '@types'

export class AddressService {
  constructor(private readonly http: Service) {}

  getPostalCodeInfo(postalCode: string): Promise<GetPostalCodeInfoResponse> {
    return this.http.get(`/v1/locations?postal_code=${postalCode}`)
  }
}
